import { useOnlineBookingReducer } from '../state/useOnlineBookingReducer';
import { StepNames } from '../Steps/consts';

export const useChangeStep = () => {
  const { dispatch, actions } = useOnlineBookingReducer();

  const changeStep = (expectedStep: StepNames[number]) => {
    dispatch(actions.changeStep(expectedStep));
  };

  return {
    changeStep,
  };
};
